import APIError from './APIError.js'

export default class TokenExpiredError extends APIError {
  constructor (id, message, status) {
    super(id, status, message)
    this.name = 'TokenExpiredError'
  }
}
